import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Link2, Check, Loader2 } from "lucide-react";
import { useState } from "react";
import { usePortfolio } from "@/hooks/usePortfolio";
import { toast } from "@/hooks/use-toast";

const tiposPortfolio = [
  { label: "GitHub", value: "github" },
  { label: "Behance", value: "behance" },
  { label: "Dribbble", value: "dribbble" },
  { label: "LinkedIn", value: "linkedin" },
  { label: "Notion", value: "notion" },
  { label: "Google Drive", value: "drive" },
  { label: "Figma", value: "figma" },
  { label: "Outro", value: "other" },
];

export default function AlunoPortfolioNovo() {
  const navigate = useNavigate();
  const { createLink } = usePortfolio();
  const [url, setUrl] = useState("");
  const [tipo, setTipo] = useState("");
  const [customTipo, setCustomTipo] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    const platform = tipo === "other" ? (customTipo.trim().toLowerCase() || "other") : tipo;
    if (!url || !tipo) {
      toast({ title: "Campos obrigatórios", description: "Preencha a URL e selecione o tipo.", variant: "destructive" });
      return;
    }
    setSaving(true);
    try {
      await createLink.mutateAsync({ url, platform });
      toast({ title: "Link adicionado!" });
      navigate("/aluno/experiencia/portfolio");
    } catch (err: any) {
      toast({ title: "Erro", description: err.message, variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-container">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="flex items-center gap-3 mb-6">
        <Button variant="ghost" size="icon" onClick={() => navigate("/aluno/experiencia/portfolio")}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="font-heading text-xl font-bold text-foreground">Adicionar Link</h1>
          <p className="text-muted-foreground text-sm">Adicione um link ao seu portfólio</p>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="space-y-6">
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">URL do link *</label>
          <div className="relative">
            <Link2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://github.com/seu-usuario" className="pl-10" />
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">Tipo de link *</label>
          <div className="grid grid-cols-2 gap-2">
            {tiposPortfolio.map((t) => (
              <button key={t.value} onClick={() => setTipo(t.value)}
                className={`p-3 rounded-xl border text-sm font-medium transition-colors ${
                  tipo === t.value ? "border-primary bg-primary/10 text-primary" : "border-border bg-card text-muted-foreground hover:border-primary/50"
                }`}>
                <div className="flex items-center justify-between">
                  <span>{t.label}</span>
                  {tipo === t.value && <Check className="w-4 h-4" />}
                </div>
              </button>
            ))}
          </div>
          {tipo === "other" && (
            <Input
              value={customTipo}
              onChange={(e) => setCustomTipo(e.target.value)}
              placeholder="Ex: Canva, Medium, YouTube..."
              className="mt-2"
            />
          )}
        </div>

        <div className="bg-accent/10 rounded-xl p-4 border border-accent/20">
          <p className="text-sm text-foreground font-medium mb-1">💡 Dica</p>
          <p className="text-xs text-muted-foreground">
            Links de portfólio ajudam empresas a verem seu trabalho real.
          </p>
        </div>

        <Button variant="hero" size="xl" className="w-full" onClick={handleSubmit} disabled={saving}>
          {saving ? (<><Loader2 className="w-5 h-5 animate-spin" />Salvando...</>) : "Adicionar Link"}
        </Button>
      </motion.div>
    </div>
  );
}
